import type { ChangedEffect } from './uiEffect.schema';

type RachelChangeHandler = (event: ChangedEffect) => void;

const subscribers = new Map<string, Set<RachelChangeHandler>>();

const buildKey = (resource: string, scopeId: string) => `${resource}/${scopeId}`;

export const rachelEventBus = {
  subscribe(resource: string, scopeId: string, handler: RachelChangeHandler): () => void {
    const key = buildKey(resource, scopeId);
    let set = subscribers.get(key);
    if (!set) {
      set = new Set();
      subscribers.set(key, set);
    }
    set.add(handler);

    return () => {
      set.delete(handler);
      if (set.size === 0) {
        subscribers.delete(key);
      }
    };
  },
  publish(event: ChangedEffect): void {
    subscribers.get(buildKey(event.resource, event.scopeId))?.forEach((handler) => handler(event));
  },
};
